import React, { forwardRef } from 'react'
import { ActionIcon, MantineColor } from '@mantine/core'

type PresenceButtonProps = {
  color: MantineColor
  onClick: () => void
  onBlur?: () => void
  error: boolean
  active: boolean
  children: React.ReactNode
}

export const PresenceButton = forwardRef<
  HTMLButtonElement,
  PresenceButtonProps
>(({ error, active, color, onClick, onBlur, children }, ref) => {
  const getColor = () => {
    if (error) {
      return 'red'
    }

    return active ? color : 'gray'
  }

  return (
    <ActionIcon
      color={getColor()}
      variant={error ? 'outline' : 'light'}
      onClick={onClick}
      onBlur={onBlur}
      ref={ref}
    >
      {children}
    </ActionIcon>
  )
})
PresenceButton.displayName = 'PresenceButton'

type RemoveAttendeeButtonProps = {
  onClick: () => void
  onBlur?: () => void
  children: React.ReactNode
}

export const RemoveAttendeeButton = forwardRef<
  HTMLButtonElement,
  RemoveAttendeeButtonProps
>(({ onClick, onBlur, children }, ref) => {
  return (
    <ActionIcon
      color="gray"
      variant="subtle"
      onClick={onClick}
      onBlur={onBlur}
      ref={ref}
    >
      {children}
    </ActionIcon>
  )
})
RemoveAttendeeButton.displayName = 'RemoveAttendeeButton'
